const idwSDKWeb = (config) => {
    window.idwSDKWeb(config);
  };
  
  export default idwSDKWeb;
  